import type { FC } from "react";

import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Image } from "~/shared/ui-kit/image";
import { Typography } from "~/shared/ui-kit/typography/Typography";

import type { MainBannerV2Props } from "../MainBannerV2";

export const MainBannerColumnItems: FC<MainBannerV2Props> = ({
  data,
  getImageUrl,
}) => {
  return (
    <Flex
      className="flex-wrap mb-9 md:mb-[76px]  "
      justify="center"
      gap={8}
      md={{ gap: 12 }}
    >
      {data?.items?.map((item) => (
        <div
          key={item?.id}
          className="bg-custom-purple/40 backdrop-blur-xl pt-2.5 pb-2 md:py-5 px-2 min-w-[308px] md:w-[370px] self-stretch transform skew-x-[-16deg]"
        >
          <Flex
            className="transform items-center text-center skew-x-[16deg] "
            flexDirection="column"
          >
            <Image
              value={getImageUrl(item?.main_banner_items_id?.icon?.id ?? "", {
                height: 32,
                width: 32,
                format: "webp",
              })}
              className="!max-h-6 md:max-h-8"
            />
            <Typography
              size="medium"
              md={{ size: "large" }}
              className="mt-2 md:whitespace-pre-line"
            >
              {item?.main_banner_items_id?.text}
            </Typography>
          </Flex>
        </div>
      ))}
    </Flex>
  );
};
